import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CollaborationContainerComponent } from '@observation/shared/components/collaboration-modal/collaboration-container/collaboration-container.component';
import { ShareAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { APPLICATION, GENERAL_ACTION_TYPES } from '../usage-tracking.config';
import { DashboardNavigationInfoService } from './dashboarad-navigation-info.service';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class ShareTrackingService implements UsageTrackingServiceInterface {
  private readonly dashboardNavigationInfoService = inject(
    DashboardNavigationInfoService
  );
  private readonly trackingService = inject(TrackingService);
  private readonly router = inject(Router);

  public addUsageTracking(element?: CollaborationContainerComponent): void {
    const action = GENERAL_ACTION_TYPES.share;
    const application = APPLICATION;

    const shareAnalytic: ShareAnalytic = {
      url: this.router.url,
      application,
      action,
      ...this.dashboardNavigationInfoService.getNavigationInfo(),
    };

    shareAnalytic.sharedBy = element.collaborationService.shareMode;
    this.trackingService.addUsageTracking(shareAnalytic);
  }
}
